import withActDetail from "../withActDetail";
import ActZoonoticForm from "./ActZoonoticForm";
import ActZoonoticPDFGenerator from "./ActZoonoticPDFGenerator";

const actFormKazakhName = 'Зоонозды және аса қауіпті инфекцияларға микробиологиялық зерттеуге үлгіні іріктеу АКТІСІ'
const actFormName = 'АКТ отбора проб внешней среды на зоонозные и особо опасные инфекции'
const actFormNumber = '010'
const actName = 'ActZoonotic'

export default withActDetail(ActZoonoticForm, ActZoonoticPDFGenerator, actFormKazakhName, actFormName, actFormNumber, actName)